import React from "react";
import useTranslation from "next-translate/useTranslation";
import { FaSignal } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa";
// import { FaDiceSix } from 'react-icons/fa';
import InfoCard from "./InfoCard";
import { useLobby } from "@/src/ducks/lobby";
import { VARIANT_CHESS, VARIANT_CHESS960 } from "@chesshotel/constants";

export default function PracticeCard({ elo, elo960 }) {
  const { t } = useTranslation("common");
  const { variant } = useLobby();

  function renderPracticeInfo() {
    return (
      <div className="flex flex-wrap items-center">
        <span className="has-tooltip">
          <span className="tooltip">
            {t("Rating")}
            {variant == VARIANT_CHESS960 && " Chess960"}
          </span>
          <div className="flex items-center">
            <div className="flex items-center justify-center text-sm text-red-400 rounded-full md:text-lg">
              <FaSignal />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-1">
              <div className="flex items-center">
                <div className="text-xs select-none md:text-md">
                  {variant == VARIANT_CHESS ? elo : elo960}
                </div>{" "}
              </div>
            </div>
          </div>
        </span>

        {/* <span className="has-tooltip">
          <span className="tooltip">{t("Rating")} Chess960</span>
          <div className="flex items-center ml-4">
            <div
              className="flex items-center justify-center flex-shrink-0 text-sm text-red-400 rounded-full md:text-lg"
            >
              <FaDiceSix />
            </div>
            <div className="flex flex-col ml-1.5 md:ml-1">
              <div className="flex items-center">
                <div className="text-xs font-semibold select-none md:text-md">
                  {elo960}
                </div>
              </div>
            </div>
          </div>
        </span> */}
      </div>
    );
  }

  return (
    // <div
    //   className="relative flex w-full p-3 mt-1 mb-2 bg-white border // md:mb-4 md:mt-0 md:p-5 md:shadow-box2 rounded-t-xl border-altgray-200 md:border-0 rounded-b-xl"
    // >
    //   <div className="flex items-center justify-center space-x-2 md:space-x-4">
    //     <div className="flex">{getIcon()}</div>
    //     <div className="flex flex-col space-y-1 md:space-y-2">
    //       <div
    //         className="flex items-center w-full space-x-1 text-base font-semibold text-altgray-700 rounded-t-xl // md:text-xl border-altgray-100"
    //       >
    //         {t("Practice")}
    //       </div>

    //     </div>
    //   </div>
    // </div>

    <InfoCard title={t("Practice")} icon={<FaGraduationCap />}>
      {renderPracticeInfo()}
    </InfoCard>
  );
}
